<template>
  <html class="h-dvh">
  <body class="h-dvh">
    <main class="grid h-dvh place-items-center bg-gradient-to-r from-gray-700 to-gray-800">
      <div class="text-center">
        <div class="flex" :class="{ 'animate-[rise_1.5s_ease-in-out_forwards]': isClicked }">
          <img class="h-28 w-auto " src="./../assets/VE_Symbol.png" alt="Your Company" />
          <h1 class="mt-4 text-gray-200 hidden font-bold tracking-tight text-7xl sm:block">hyperLayer</h1>
        </div>
        <div class="mt-5 flex items-center justify-center gap-x-6">
          <button v-if="!isClicked" class="rounded-md bg-[#36a8dd] px-5 py-1 text-lg text-gray-200 shadow-sm hover:bg-sky-600 focus-visible:outline focus-visible:outline-2 
            focus-visible:outline-offset-2 focus-visible:outline-indigo-600" @click="Login">
            Login</button>
          <ProgressSpinner v-else class="absolute h-90 w-90" attrs-color-black strokeWidth="5"
            animationDuration="1s" aria-label="Loading" />
        </div>
      </div>
    </main>
  </body>

  </html>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "@vue/runtime-core";
import { authStore } from "../store/index";
import { useRouter, useRoute } from 'vue-router'
import ProgressSpinner from 'primevue/progressspinner';

const router = useRouter()
const auth = authStore();
onMounted(async () => {
  if (auth.tokenValid) {
    router.push("/statsearch")
  }
});

const isClicked = ref(false)

function Login() {
  isClicked.value = true
  auth.login().then((e)=>{
    router.push("/statsearch")
  })
}
</script>

<style>
@keyframes p-progress-spinner-color {

  100%,
  0% {
    stroke: #36a8dd;
  }
}
</style>
